
import {Component, Prop, Vue} from "vue-property-decorator";
import {stringify} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'TextFieldReadonly',
  components: {
  },
})
export default class TextFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get labelField() {
    return this.displayName.length <= 50 ? this.displayName : ""
  }

  get labelAbove() {
    return this.displayName.length > 50 ? this.displayName : ""
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  get counter() {
    return this.field.definition.maxLength ?? 200
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get value() {
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  get field() {
    return this.dataField;
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }

}
